import { Box, Heading, HStack, Link, Stack, VStack } from '@chakra-ui/react'
import React from 'react'
import {TiSocialLinkedinCircular,TiSocialInstagramCircular, TiSocialGithubCircular} from "react-icons/ti"
import {DiGithub} from 'react-icons/di'
import logo from "../../../assets/images/education-logo-design.jpg"
const Footer = () => {
  return (
    <Box padding={'4'} bg="blackAlpha.900" minH={'10vh'}>
        <Stack direction={['column','row']}>
            <VStack alignItems={['center','flex-start']} width='full'>
               <a href="/"> <img  src={logo} style={{width:50,height:50,borderRadius:'50%'}} alt="fireSpot"/> </a>
            </VStack>
            <HStack color={'white'} fontSize='50' spacing={['2','10']} justifyContent='center'>
                <a href="https://www.instagram.com/its.abhinav_/" target={'blank'}>
                    <TiSocialInstagramCircular/>
                </a>
                <a href="https://www.linkedin.com/in/abhinav-malhotra-9688ab218/" target={'blank'}>
                    <TiSocialLinkedinCircular/> 
                </a>
                <a href="https://github.com/abhinavmalhotra01" target={'blank'}>
                    <DiGithub/>
                </a>
            </HStack>
        </Stack>
        <VStack alignItems={['center']} width='full'>
            <HStack>
            <Heading children="All Rights Reserved" size={'sm'} fontFamily='body'  color={'gray'}/>
            <Heading fontFamily={'body'} size='sm' children="@Abhinav Malhotra" color={'yellow.400'}/>
            </HStack>
        </VStack>
    </Box>
  )
}

export default Footer